import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  IconButton,
  Collapse,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalculateIcon from '@mui/icons-material/Calculate';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import LensBlurIcon from '@mui/icons-material/LensBlur'; // v5用アイコン
import AdjustIcon from '@mui/icons-material/Adjust'; // v4用アイコン

const Sidebar = ({ open, onClose, drawerWidth, variant }) => {
  const location = useLocation();

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

  const [dahaiMenuOpen, setDahaiMenuOpen] = useState(false);

  // 現在のパスが打牌推論ページの場合、サブメニューをデフォルトで開く
  useEffect(() => {
    if (location.pathname.startsWith('/dahai-prediction')) {
      setDahaiMenuOpen(true);
    }
  }, [location.pathname]);

  const handleDahaiMenuToggle = () => {
    setDahaiMenuOpen(!dahaiMenuOpen);
  };

  const drawerContent = (
    <>
      <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: [1] }}>
        <IconButton onClick={onClose}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <List component="nav">
        <ListItemButton component={RouterLink} to="/" selected={location.pathname === '/'} onClick={variant === 'temporary' ? onClose : undefined}>
          <ListItemIcon><HomeIcon /></ListItemIcon>
          <ListItemText primary="ホーム" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        {/* 打牌推論 (折りたたみメニュー) */}
        <ListItemButton onClick={handleDahaiMenuToggle}>
          <ListItemIcon><DashboardIcon /></ListItemIcon>
          <ListItemText primary="打牌推論" sx={{ opacity: open ? 1 : 0 }} />
          {open ? (dahaiMenuOpen ? <ExpandLess /> : <ExpandMore />) : null}
        </ListItemButton>
        <Collapse in={open && dahaiMenuOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton component={RouterLink} to="/dahai-prediction/v5" selected={location.pathname === '/dahai-prediction/v5'} onClick={variant === 'temporary' ? onClose : undefined} sx={{ pl: 4 }}>
              <ListItemIcon><LensBlurIcon /></ListItemIcon>
              <ListItemText primary="v5 (七対子対応)" sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
            <ListItemButton component={RouterLink} to="/dahai-prediction/v4" selected={location.pathname === '/dahai-prediction/v4'} onClick={variant === 'temporary' ? onClose : undefined} sx={{ pl: 4 }}>
              <ListItemIcon><AdjustIcon /></ListItemIcon>
              <ListItemText primary="v4 (旧モデル)" sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton component={RouterLink} to="/agarihai-calculation" selected={location.pathname === '/agarihai-calculation'} onClick={variant === 'temporary' ? onClose : undefined}>
          <ListItemIcon><CalculateIcon /></ListItemIcon>
          <ListItemText primary="アガリ牌計算" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>
        <ListItemButton component={RouterLink} to="/detection" selected={location.pathname === '/detection'} onClick={variant === 'temporary' ? onClose : undefined}>
          <ListItemIcon><CameraAltIcon /></ListItemIcon>
          <ListItemText primary="牌検出" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>
        {/* 新機能はここに追加します */}
      </List>
    </>
  );

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={variant === 'temporary' ? onClose : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(variant === 'permanent' && open && {
          ...openedMixin,
          '& .MuiDrawer-paper': openedMixin,
        }),
        ...(variant === 'permanent' && !open && {
          ...closedMixin,
          '& .MuiDrawer-paper': closedMixin,
        }),
        ...(variant === 'temporary' && {
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        }),
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export default Sidebar;